// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__CW_Q3","buttons":"SendReceipts_buttons__2B04r","email":"SendReceipts_email__2ovG4","bookApptTitle":"SendReceipts_bookApptTitle__3J33Y"};